/**
 * Classe para adicionar
 * @author: Adalto Junior
 * DATE:08/09/2014
 *
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};
Monet.UI.Fields.PowerLookupList = (function () {

    function PowerLookupList() {

        Monet.UI.Fields.PowerLookup.apply(this, arguments);

        this.selectedValues = {};

        this.baseSelector = '';
        this.enableColumnCheckBok = true;
        this.listValue = [];
        this.customCriteriaChain = [];
        this.customProjectionSelectAll = null;
        this.originalValues = null;
        this.callbackAfterFilter = () => undefined;

        const destroyItemHandler = (event) => {
            this.destroyItem(event.currentTarget.parentElement);
        }

        var renderInputHiddenToItemLookupList = function (entity, id) {

            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = entity + '[' + id + '].id';
            input.id = entity + '[' + id + '].id';
            input.className = 'modelAttribute';
            input.value = id;

            return input;

        };

        this.setCallbackAfterFilter = callback => {
            this.callbackAfterFilter = callback;
        };

        this.setCustomProjectionToSelectAll = (customProjectionSelectAll) => {
            this.customProjectionSelectAll = customProjectionSelectAll;
        };

        this.getFullValue = function () {

            var listFullValue = [];

            var transform = function (item) {
                var json = {id: item.id};
                json[this.displayKey] = item[this.displayKey];
                return json;
            };

            for (var key in this.selectedValues) {
                if (this.selectedValues.hasOwnProperty(key)) {
                    var item = this.selectedValues[key];
                    listFullValue.push(transform.call(this, item));
                }
            }

            return listFullValue;

        };

        this.getSelectedValues = function () {
          return this.selectedValues;
        }

        this.removeItemFromListValue = function (itemDestroyed) {
            this.listValue.forEach(function (item, index) {
                if (this.meta && this.meta.hasMany) {
                    item = item[this.meta.hasMany.entityName];
                }

                if(typeof itemDestroyed === "string") {
                    itemDestroyed = parseInt(itemDestroyed);
                }

                if (item && item.id === itemDestroyed) {

                    this.listValue.splice(index, 1);
                    delete this.selectedValues[item.id];
                }
            }, this);

            if (this.postRemoveItemCallback) {
                this.postRemoveItemCallback(itemDestroyed);
            }

            this.triggerChange();
        };

        this.destroyItem = function (nodeElement) {
            this.divLookupListWrapper.removeChild(nodeElement);
            this.removeItemFromListValue(nodeElement.id);
        };


        this.clear = (options) => {
            const nodes = this.divLookupListWrapper.childNodes;
            while (nodes.length) {
                this.divLookupListWrapper.removeChild(nodes[0]);
            }
            this.listValue = [];
            this.selectedValues = [];
            this.triggerChange(options);
        };

        this.createItemLookupList = function (id, value) {

            var entity = this.lookUpEntity.toLowerCase();
            var idItem = entity + '_' + id;
            var item = document.createElement('div');

            item.id = id;
            item.className = `zebrado item_lookuplist_${idItem}`;

            var description = document.createElement('div');
            description.className = 'title_item_added';
            description.innerHTML = Monet.I18n.getResourcesByKey(value);

            var iconDestroy = document.createElement('div');
            iconDestroy.className = 'del_item_added';

            var link = document.createElement('div');
            link.className = 'table-action-destroylink';
            link.innerHTML = '&nbsp;';

            var divStyle = document.createElement('div');
            divStyle.style.clear = 'both';

            item.appendChild(description);
            item.appendChild(iconDestroy);
            iconDestroy.appendChild(link);
            item.appendChild(divStyle);

            if (this.renderCustomInputHiddenToItemLookupList) {
                item.appendChild(this.renderCustomInputHiddenToItemLookupList(id));
            } else {
                item.appendChild(renderInputHiddenToItemLookupList(entity, id));
            }

            this.divLookupListWrapper.appendChild(item);

            const itemName = `item_lookuplist_${idItem}`;
            item.setAttribute('name', itemName);
            iconDestroy.itemName = itemName;
            iconDestroy.addEventListener('click', destroyItemHandler);

            return item;

        };

        this.getValue = function () {
            return this.listValue;
        };

        this.getFilterValue = function () {
            return this.listValue.map((value) => this.getValueFromJsonElement(value).id);
        };

        this.transformModelToJson = function (model) {
            return model.attributes || model;
        };

        this.getValueFromJsonElement = function (jsonElement) {
            return jsonElement[this.meta?.hasMany?.entityName] || jsonElement;
        };

        this.getValueWithId = function (item) {
            const json = {};

            if (this.meta?.hasMany) {
                const nestedEntity = this.meta.hasMany.entityName;
                const nestedId = item.id;
                const originalValue = this.originalValues.find(value => value[nestedEntity] && value[nestedEntity].id === nestedId);
                if (originalValue) {
                    json.id = originalValue.id;
                }
                json[nestedEntity] = { id: nestedId, [this.displayKey]: item[this.displayKey] };
            } else {
                json.id = item.id;
                json[this.displayKey] = item[this.displayKey];
            }
            return json;
        };

        this.setValue = function (items, options) {
            const setValueCollection = () => {
                const transformed = items.map(this.transformModelToJson);
                this.originalValues = this.originalValues || transformed;
                transformed.forEach((item) => {
                    const element = this.getValueFromJsonElement(item);
                    
                    if (!this.selectedValues[element.id] && element.id) {
                        const renderedItem = this.createItemLookupList(element.id, element[this.displayKey] || element?.stop?.key || element.key);
                        const value = this.getValueWithId(element);
                        if (this.listValue.filter(item => item.id === element.id).length === 0) {
                            this.listValue.push(value);
                        }
                        this.selectedValues[element.id] = element;

                        if (this.postCreateItemCallback) {
                            this.postCreateItemCallback(renderedItem);
                        }
                    }
                });
            };

            if (options && options.cleanChange) {
                this.clear({ doNotTriggerChange: true });
            }

            if (items?.length) {
                if (!items[0][this.meta?.hasMany?.entityName]?.id && !items[0].id) {
                    this.listValue = items.map((item) => this.getValueFromJsonElement(item));

                    if (!this.listValue.id) {
                        this.listValue = items.map(function(item){
                            return {id: item};
                        });
                    }

                    const requestFieldData = () => {
                        this.requestWithFieldID((collection) => {
                            this.setValue(collection.models);

                            this.callbackAfterFilter && this.callbackAfterFilter();
                        });
                    };

                    if (this.filter) {
                        requestFieldData();
                    } else {
                        this.setAfterCreateFilter(requestFieldData);
                    }
                } else {
                    setValueCollection();
                }
            } else {
                this.clear(options);
            }

            this.triggerChange(options);
        };

        this.getCriteria = function() {
            const ids = this.getFilterValue();
            const criteria = {
                criteriaChain: [{
                    and: []
                }]
            };

            if (ids?.length) {
                criteria.criteriaChain[0].and = [{
                    attr: "id",
                    in : ids
                }];
            }

            return criteria;
        }.bind(this);

        this.listenerToAfterSelectRow = function (allItemsSelected) {
            const items = allItemsSelected || this.grid.getItemsSelected();
            this.setValue(items);
            this.grid.setSelectedRows([]);
            this.hideContainer(this);
            this.listenersToAfterSelectRow.forEach(listener => {
                listener(items);
            });
        };

        this.createFloatContainer = function () {

            this.resultContainer = document.createElement('div');
            this.maximizeFilterBtn = document.createElement('div');
            this.configureGridLayout = document.createElement('div');
            this.btnGetItemsChecked = document.createElement('div');
            this.filterContainer = document.createElement('div');
            this.statusBarContainer = document.createElement('div');
            this.statusBarText = document.createElement('span');

            this.resultContainer.className = 'MonetUIFieldsLookupFloatResultContainer hasStatusBar';
            this.maximizeFilterBtn.className = 'MonetUIFieldsLookupMaximizeFilterFields';
            this.configureGridLayout.className = 'MonetUIFieldsLookupConfigureGridLayout';
            this.btnGetItemsChecked.className = 'MonetUIFieldsLookupGetItemsChecked';
            this.statusBarContainer.className = 'MonetUIFieldsLookupStatusBar';

            if (navigator.userAgent.indexOf('Windows') !== -1) {
                this.maximizeFilterBtn.style.right = '64px';
                this.btnGetItemsChecked.style.right = '41px';
            }

            this.resultContainer.appendChild(this.maximizeFilterBtn);
            this.resultContainer.appendChild(this.btnGetItemsChecked);
            this.resultContainer.appendChild(this.configureGridLayout);
            this.resultContainer.appendChild(this.filterContainer);
            this.resultContainer.appendChild(this.gridContainerEl);
            this.statusBarContainer.appendChild(this.statusBarText);
            this.resultContainer.appendChild(this.statusBarContainer);

        };

        this.createElement = function () {

            this.inputContainer = document.createElement('div');
            this.inputContainer.className = 'lookupInputContainer';
            
            this.input = document.createElement('input');
            this.input.type = 'text';
            this.input.className = 'lookUpField';
            this.input.style.display = 'none';
            this.input.setAttribute('rel', this.displayKey);
            this.input.setAttribute('autocomplete', 'off');

            this.formattedValue = document.createElement('input');
            this.formattedValue.className = 'formattedValue lookUpField';
            this.formattedValue.type = 'text';

            this.searchButton = document.createElement('div');
            this.searchButton.className = 'lookupSearchButton';

            this.inputContainer.appendChild(this.formattedValue);
            this.inputContainer.appendChild(this.input);
            this.inputContainer.appendChild(this.searchButton);

            this.idHidden = document.createElement('input');
            this.idHidden.type = 'hidden';
            this.idHidden.className = 'modelAttribute';

            this.divLookupListDisabled = document.createElement('div');
            this.divLookupListDisabled.className = 'lookupList-disabled';

            this.divLookupList = document.createElement('div');
            this.divLookupList.className = 'container_lookuplist_added';
            this.divLookupList.id = this.lookUpEntity.toLowerCase() + '_list';
            this.divLookupList.appendChild(this.divLookupListDisabled);

            this.divLookupListWrapper = document.createElement('div');
            this.divLookupListWrapper.className = 'MonetUIFieldsLookupListItemsWrapper';
            this.divLookupList.appendChild(this.divLookupListWrapper);

            this.removeAllElementsButton = document.createElement('div');
            this.removeAllElementsButton.className = 'power-lookup-list-remove-all-elements'
            this.removeAllElementsButton.innerHTML = `<i class="fa fa-trash-o"></i> ${Monet.I18n.getResourcesByKey('lookupList.removeAllElements')}`;
            this.divLookupList.appendChild(this.removeAllElementsButton);

            this.rootEl.className = 'lookupList';

            const resultContainerWrapper = document.createElement('div');
            resultContainerWrapper.appendChild(this.resultContainer);

            const divLookupListWrapper = document.createElement('div');
            divLookupListWrapper.appendChild(this.divLookupList);
            
            this.lookupContainer = document.createElement('div');
            this.lookupContainer.className = 'lookupContainer';
            this.lookupContainer.appendChild(this.inputContainer);
            this.lookupContainer.appendChild(resultContainerWrapper);
            this.lookupContainer.appendChild(divLookupListWrapper);
            this.rootEl.appendChild(this.lookupContainer);
            this.rootEl.appendChild(this.idHidden);

            const handleHoverInputContainer = () => {
                const reactInputContainer = this.inputContainer.getBoundingClientRect();
                const LOOKUP_TOP = reactInputContainer.top + this.inputContainer.clientHeight;
                const topListAdded  = reactInputContainer ? `${LOOKUP_TOP}px` : "";
                const isListFilter = this.divLookupList.classList.contains("lookupListFilter");

                if(isListFilter) {
                    this.divLookupList.style.top = topListAdded;
                }
            }

            this.inputContainer.addEventListener("mouseover", handleHoverInputContainer);
        };

        this.disableAll = function() {
            this.disable();
            if (this.divLookupList) {
                this.divLookupList.classList.add('container_lookuplist_added--disabled');
                const selectedItems = this.listValue;
                this.divLookupListDisabled.style.top = `${this.divLookupList.scrollTop}px`;
                selectedItems.forEach(item => {
                    const entity = this.lookUpEntity.toLowerCase();
                    const removalIconElement = this.divLookupList.querySelector(`.item_lookuplist_${entity}_${item.id} .del_item_added`);
                    if (removalIconElement) {
                        removalIconElement.removeEventListener('click', destroyItemHandler);
                    }
                });
                
            }
            
        };

        this.enableAll = function() {
            this.enable();
            if (this.divLookupList) {
                this.divLookupList.classList.remove('container_lookuplist_added--disabled');
                const selectedItems = this.listValue;
                selectedItems.forEach(item => {
                    const entity = this.lookUpEntity.toLowerCase();
                    const removalIconElement = this.divLookupList.querySelector(`.item_lookuplist_${entity}_${item.id} .del_item_added`);
                    if (removalIconElement) {
                        removalIconElement.addEventListener('click', destroyItemHandler);
                    }
                });
            }
        }

        this.clearFilterUserAction = () => {
            if (!this.getValue().length) {
                this.clear();
            }
        };

    }

    return PowerLookupList;

}());
